
import { useState, useEffect } from 'react';
import {ApiUrl} from "../../ApiUrl"

const useFetchProfession = () => {
  const [profession , setProfession ] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProfession = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}PROFESSION/GetAllProfession/`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setProfession(Array.isArray(data?.data) ? data.data : []);
      } catch (err) {
        setError(err.message);
        setProfession([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProfession();
  }, []);

  return { profession, loading, error };
};

export default useFetchProfession;
